import { Nullable } from '@crossbeam/types';

import { InjectionKey, Ref } from 'vue';

type AttributionMetrics = {
  totalSourced: Nullable<number>;
  totalInfluenced: Nullable<number>;
  totalAttributed: Nullable<number>;
};

type OfflineSource = {
  id: number;
  [key: string]: unknown;
};

type OfflinePopulation = {
  id: number;
  [key: string]: unknown;
};

type OfflinePopulationStat = Record<string, unknown>;

/** Total attribution metrics for a partner */
export const ProvidedTotalAttribution: InjectionKey<Ref<AttributionMetrics>> =
  Symbol('ProvidedTotalAttribution');

/** Offline partner data sources */
export const ProvidedOfflineSources: InjectionKey<Ref<OfflineSource[]>> =
  Symbol('ProvidedOfflineSources');

/** Current upload names for offline partner data */
export const ProvidedOfflineCurrentUploadNames: InjectionKey<Ref<string[]>> =
  Symbol('ProvidedOfflineCurrentUploadNames');

/** Offline partner populations */
export const ProvidedOfflinePopulations: InjectionKey<
  Ref<OfflinePopulation[]>
> = Symbol('ProvidedOfflinePopulations');

/** Function to refresh offline partner data */
export const ProvidedRefreshOfflineData: InjectionKey<
  (offlinePartnerUuid: string, rethrow?: boolean) => Promise<void>
> = Symbol('ProvidedRefreshOfflineData');

/** Function to delete an offline source */
export const ProvidedDeleteOfflineSource: InjectionKey<
  (sourceId: number, offlinePartnerUuid: string) => Promise<void>
> = Symbol('ProvidedDeleteOfflineSource');

/** Function to delete an offline population */
export const ProvidedDeleteOfflinePopulation: InjectionKey<
  (populationId: number, offlinePartnerUuid: string) => Promise<void>
> = Symbol('ProvidedDeleteOfflinePopulation');

/** Statistics for offline populations */
export const ProvidedOfflinePopulationStats: InjectionKey<
  Ref<OfflinePopulationStat[]>
> = Symbol('ProvidedOfflinePopulationStats');
